import React, { useContext } from 'react';

const NotificationsContext = React.createContext({
  show() {},
  showNamed() {},
  showById() {},
  dismiss() {},
  disabled: false,
  message: '',
  target: null,
  visible: false,
  messageIcon: '',
});

export const withNotifications = (Component) => {
  const NotificationsComponent = (props) => {
    return (
      <NotificationsContext.Consumer>
        {(notifications) => (
          <Component {...props} notifications={notifications} />
        )}
      </NotificationsContext.Consumer>
    );
  };
  const displayName = Component.displayName || Component.name || 'Component';
  NotificationsComponent.displayName = `${displayName}WithNotifications`;
  return NotificationsComponent;
};

export const useNotifications = () => useContext(NotificationsContext);

export default NotificationsContext;
